/**
 * LandmarkControls.jsx
 * Visibility toggles for landmarks. Position and size are controlled by
 * dragging directly on the map canvas.
 */
import React from 'react';
import { Box, Typography, Divider, Switch, FormControlLabel } from '@mui/material';
import { LANDMARK_LABELS, LANDMARK_ICONS } from '../../business/SeatingMapWidget/seatingMapUtils';

const LandmarkControls = ({ landmarks, onUpdate }) => {
  return (
    <Box>
      <Divider sx={{ my: 1.5 }} />
      <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1, color: '#1e3a5f' }}>
        נקודות ציון
      </Typography>

      {landmarks.map(lm => (
        <Box
          key={lm.id}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mb: 0.5,
            opacity: lm.visible === false ? 0.5 : 1,
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            {LANDMARK_ICONS[lm.type]} {LANDMARK_LABELS[lm.type]}
          </Typography>
          <FormControlLabel
            control={
              <Switch
                size="small"
                checked={lm.visible !== false}
                onChange={(e) => onUpdate(lm.id, { visible: e.target.checked })}
                sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: '#1e3a5f' } }}
              />
            }
            label=""
            sx={{ m: 0 }}
          />
        </Box>
      ))}

      <Typography variant="caption" sx={{ color: '#aaa', fontSize: 10, display: 'block', mt: 0.5 }}>
        גרור על המפה למיקום ושינוי גודל
      </Typography>
    </Box>
  );
};

export default LandmarkControls;
